// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falCircleEllipsis: CreateIconOptions = {
  "displayName": "FALCircleEllipsis",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM184 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z"
};
